import React from 'react'

// redux
import { connect } from "react-redux";

function PaymentForm(props) {
    // props
    const { 
        submitBtnRef,
        cartDetails,

        formik
    } = props

    return (
        <div className="custom-payment-form">
            <form
                onSubmit={formik.handleSubmit}
                noValidate
                autoComplete="off">
                <div className="form-main d-flex flex-wrap">
                    {/* form item */}
                    <div className={`form-item credit-card ${(formik.touched.cardNumber && formik.errors.cardNumber) ? "has-error" : ""}`}>
                        <label className="st-fw-600 st-fs-13">Card Number</label>
                        <input 
                            type="number"
                            className="form-control mb-0"
                            placeholder="1234 1234 1234 1234"
                            {...formik.getFieldProps('cardNumber')}
                            onChange={ev => {
                                const inpVal = ev.target.value
                                
                                if(inpVal?.length <= 16) {
                                    formik.setFieldValue("cardNumber", inpVal)
                                }
                            }}
                        />
                        
                        {/* error msg */}
                        {
                            (formik.touched.cardNumber && formik.errors.cardNumber) ? (
                                <div className="error-msg">
                                    {formik.errors.cardNumber}
                                </div>
                            ) : null
                        }
                    </div>

                    {/* form item */}
                    <div className={`form-item expiry-month ${(formik.touched.expiryMonth && formik.errors.expiryMonth) ? "has-error" : ""}`}>
                        <label className="st-fw-600 st-fs-13">Expiry Month</label>
                        <select
                            {...formik.getFieldProps('expiryMonth')}
                            className="form-control mb-0"
                        >
                            <option disabled value="">Select Month</option>
                            <option value="01">01</option>
                            <option value="02">02</option>
                            <option value="03">03</option>
                            <option value="04">04</option>
                            <option value="05">05</option>
                            <option value="06">06</option>
                            <option value="07">07</option>
                            <option value="08">08</option>
                            <option value="09">09</option>
                            <option value="10">10</option>
                            <option value="11">11</option>
                            <option value="12">12</option>
                        </select>                    
                        {/* error msg */}
                        {
                            (formik.touched.expiryMonth && formik.errors.expiryMonth) ? (
                                <div className="error-msg">
                                    {formik.errors.expiryMonth}
                                </div>
                            ) : null
                        }
                    </div>

                    {/* form item */}
                    <div className={`form-item expiry-year ${(formik.touched.expiryYear && formik.errors.expiryYear) ? "has-error" : ""}`}>
                        <label className="st-fw-600 st-fs-13">Expiry Year</label>
                        <select
                            {...formik.getFieldProps('expiryYear')}
                            className="form-control mb-0"
                        >
                            <option disabled value="">Select Year</option>
                            <option value="2022">2022</option>
                            <option value="2023">2023</option>
                            <option value="2024">2024</option>
                            <option value="2025">2025</option>
                            <option value="2026">2026</option>
                            <option value="2027">2027</option>
                            <option value="2028">2028</option>
                            <option value="2029">2029</option>
                            <option value="2030">2030</option>
                            <option value="2031">2031</option>
                            <option value="2032">2032</option>
                            <option value="2033">2033</option>
                            <option value="2034">2034</option>
                            <option value="2035">2035</option>
                            <option value="2036">2036</option>
                            <option value="2037">2037</option>
                            <option value="2038">2038</option>
                            <option value="2039">2039</option>
                            <option value="2040">2040</option>
                        </select>
                        {/* <input 
                            type="text"
                            className="form-control mb-0"
                            placeholder="YYYY"
                            {...formik.getFieldProps('expiryYear')}
                            onChange={ev => {
                                const inpVal = ev.target.value
                                
                                if(inpVal?.length <= 4) {
                                    formik.setFieldValue("expiryYear", inpVal)

                                    if((inpVal?.length === 4) && (parseInt(inpVal) < new Date().getFullYear())) { // if less than current year
                                        setTimeout(() => {
                                            formik.setFieldValue("expiryYear", new Date().getFullYear())
                                        }, 500);
                                    }
                                }
                            }}
                        /> */}
                        
                        {/* error msg */}
                        {
                            (formik.touched.expiryYear && formik.errors.expiryYear) ? (
                                <div className="error-msg">
                                    {formik.errors.expiryYear}
                                </div>
                            ) : null
                        }
                    </div>

                    {/* form item */}
                    <div className={`form-item cvv ${(formik.touched.cvv && formik.errors.cvv) ? "has-error" : ""}`}>
                        <label className="st-fw-600 st-fs-13">CVV</label>
                        <input 
                            type="number"
                            className="form-control mb-0"
                            placeholder="CVV"
                            {...formik.getFieldProps('cvv')}
                            onChange={ev => {
                                const inpVal = ev.target.value
                                if(inpVal?.length <= 4) {
                                    formik.setFieldValue("cvv", inpVal)
                                }
                            }}
                        />
                        
                        {/* error msg */}
                        {
                            (formik.touched.cvv && formik.errors.cvv) ? (
                                <div className="error-msg">
                                    {formik.errors.cvv}
                                </div>
                            ) : null
                        }
                    </div>

                    {/* btn */}
                    <div className="btn-container">
                        <button className="btn btn-dark" onClick={ev => {
                            ev.preventDefault()

                            submitBtnRef?.current?.click()
                        }}>
                            Pay {cartDetails?.cart_total ?? 0}
                        </button>
                    </div>
                </div>
            </form>
        </div>
    )
}


const getDataFromStore = (state) => {
    return {
        cartDetails: state.cart.cartDetails,
    };
};

export default connect(getDataFromStore, null)(PaymentForm);